/***************************************************************************************************
** parseJson
***************************************************************************************************/

export default function parseJson(value, options = {}) {
  if (!value) return options.fallback;
  if (typeof value !== "string") return value;

  try {
    const parsedValue = JSON.parse(value);
    return parsedValue ?? options.fallback;
  } catch(error) {
    console.error(`Failed to parse JSON: ${value}`, error);
    return options.fallback;
  }
}
